import React, { useState } from 'react';
import axios from 'axios';
import { REACT_APP_API_URL } from '../../../../../../env';

const AddFacility = () => {
  const [facility, setFacility] = useState({ title: '', description: '' });

  const handleChange = (e) => {
    setFacility({ ...facility, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${REACT_APP_API_URL}api/facilities/room-facilities`,{
        facilityID: facility.facilityID,
        facilityTitle: facility.title,
        facilityDescription: facility.description
      });
      console.log(response, 'Response');
      alert('Facility added successfully!');
      setFacility({ title: '', description: '' });
    } catch (error) {
      alert('Error adding facility');
      console.error(error);
    }
  };

  return (
    <div className="modal fade" id="add-facilites" tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">Add Room Facility</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label text-muted">Facility Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Add Facility Title"
                  name="title"
                  value={facility.title}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group mt-3">
                <label className="form-label text-muted">Facility Description</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Add Facility Description"
                  name="description"
                  value={facility.description}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="modal-footer mt-3">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="submit" className="btn btn-secondary">Save changes</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddFacility;
